var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHarmonyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 288,
    viewBox: "0 0 318 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159 34.1543C137.902 34.1543 117.059 38.8112 97.6781 47.8025C78.3031 56.7909 60.8142 69.9117 46.1596 86.3248C31.508 102.735 19.9618 122.128 12.109 143.361C4.25653 164.594 0.230711 187.303 0.230713 210.204C0.230713 210.707 0.255907 211.205 0.305104 211.695C0.255543 213.436 0.230713 215.179 0.230713 216.924C0.230713 225.08 6.84312 231.693 14.9999 231.693C23.1568 231.693 29.7692 225.08 29.7692 216.924C29.7692 198.22 33.1709 179.723 39.7565 162.5C46.3417 145.277 55.9666 129.7 68.029 116.633C80.0893 103.567 94.3422 93.2723 109.94 86.2731C125.534 79.2756 142.201 75.6928 159 75.6928C175.799 75.6928 192.466 79.2755 208.06 86.2731C223.658 93.2723 237.911 103.567 249.971 116.633C262.033 129.7 271.658 145.277 278.243 162.5C284.829 179.723 288.231 198.22 288.231 216.924C288.231 225.08 294.843 231.693 303 231.693C311.157 231.693 317.769 225.08 317.769 216.924C317.769 215.179 317.744 213.436 317.695 211.695C317.744 211.205 317.769 210.707 317.769 210.204C317.769 187.303 313.743 164.594 305.891 143.361C298.038 122.128 286.492 102.735 271.84 86.3248C257.186 69.9117 239.697 56.7909 220.322 47.8025C200.94 38.8112 180.098 34.1543 159 34.1543Z",
    fill: "#3A3A3C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 159.923,
    cy: 216.923,
    r: 36.9231,
    fill: "#3A3A3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarmonyLogo);
export default __webpack_public_path__ + "static/media/harmony_logo.d047effcd2b706989b74217547581445.svg";
export { ForwardRef as ReactComponent };